// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.automation_tab-button__oeCZP {
    background-color: #FFFFFF;
    color: #5D8EA4;
    width: 126px;
    height: 34px;
    font-size: 14px;
    border-radius: 5px;
    border: none;
    margin-right: 5px;
}

.automation_notification-container__dTmUN {
    overflow-y: scroll;
    max-height: 70vh
}

.automation_notification-container__dTmUN::-webkit-scrollbar {
    display: none;
}

.automation_add-layer-button__rHLBH {
    border: 1px solid #0095FF;
    color: #0095FF;
    background: none;
    width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450
}

.automation_tab-button-active__hydKu {
    background-color: #0095FF;
    color: #FFFFFF;
}

.automation_tab-content-container__J85PV {
    margin-top: 20px;
    width: 100%
}

.automation_form-textfield__b5Hvw {
    margin-bottom: 10px
}

.automation_server-content__87chh {
    padding: 30px;
    background-color: var(--color-content);
    color: var(--color-main-typography);

    width: 100%;
    height: 100vh;
}

.automation_server-tabs-background__\\+ZUdC {
    width: 100%;
    height: 100%;
    background-color: var(--color-content-sidebar);
    padding: 5px;
    border-radius: 5px;;
}

.automation_server-content-info-url-container__FXeng {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    margin-top: 20px
}

.automation_server-content-info-url-container-item__kqUNx {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    width: 183px;
}

.automation_server-settings-button__eX0k7 {
    border: 1px solid #0095FF;
    color: #0095FF;
    background: none;
    width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450
}

.automation_server-settings-secondary__0oQHT {
    font-size: 10px;
    font-weight: 450;
    color: #8E99A0
}

.automation_server-settings-highlighted__m2jCC {
    font-size: 12px;
    font-weight: 450;
    color: #0095FF;
    text-decoration: underline;
}

.automation_servers-info-table__VgRuv {
    border-collapse: collapse;
    width: 90%;
    margin-top: 10px;
}

.automation_servers-info-row__ddmD6 {
    border: none;
    height: 34px;
    text-align: left;
    font-size: 14px;
    font-weight: 450;
    padding: 5px;
    color: var(--color-secondary-typography);
}

.automation_servers-info-row__ddmD6:nth-child(odd) {
    background-color: var(--color-content-sidebar);
}

.automation_mainWrapper__7hroN {
    flex: 1 1;
    height: 100vh;
    display: flex;
    align-items: flex-start;
}

.automation_rightBlock__EKup2 {
    flex: 1 1;
    background: var(--color-content);
    height: 100vh;
    padding: 30px;
    color: var(--color-main-typography)
}

.automation_search-controls-container__vYi1T {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0;
}

.automation_search-field-container__D9n5a {
    display: flex;
    flex: 16 1;
}

.automation_search-filter-container__lOS9z {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 3 1;
}

.automation_content-heading__dpi01 {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 20px;
}

.automation_content-container__6pkKq {
    padding: 0;
}

.automation_search-controls__mPm8g {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}

.automation_search-container__pWwtg {
    width: 444px;
}

@media screen and (max-width: 1000px) {
    .automation_server-content-info-url-container__FXeng {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 5px;
        margin-top: 20px
    }

    .automation_mainWrapper__7hroN {
        width: 100%;
    }

    .automation_rightBlock__EKup2 {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .automation_content-container__6pkKq {
        padding: 30px;
    }

    .automation_content-heading-container__NEqll {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cameras/automation.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;;IAEnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;QAC3B,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":[".tab-button {\n    background-color: #FFFFFF;\n    color: #5D8EA4;\n    width: 126px;\n    height: 34px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: none;\n    margin-right: 5px;\n}\n\n.notification-container {\n    overflow-y: scroll;\n    max-height: 70vh\n}\n\n.notification-container::-webkit-scrollbar {\n    display: none;\n}\n\n.add-layer-button {\n    border: 1px solid #0095FF;\n    color: #0095FF;\n    background: none;\n    width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450\n}\n\n.tab-button-active {\n    background-color: #0095FF;\n    color: #FFFFFF;\n}\n\n.tab-content-container {\n    margin-top: 20px;\n    width: 100%\n}\n\n.form-textfield {\n    margin-bottom: 10px\n}\n\n.server-content {\n    padding: 30px;\n    background-color: var(--color-content);\n    color: var(--color-main-typography);\n\n    width: 100%;\n    height: 100vh;\n}\n\n.server-tabs-background {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-content-sidebar);\n    padding: 5px;\n    border-radius: 5px;;\n}\n\n.server-content-info-url-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 5px;\n    margin-top: 20px\n}\n\n.server-content-info-url-container-item {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: flex-start;\n    width: 183px;\n}\n\n.server-settings-button {\n    border: 1px solid #0095FF;\n    color: #0095FF;\n    background: none;\n    width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450\n}\n\n.server-settings-secondary {\n    font-size: 10px;\n    font-weight: 450;\n    color: #8E99A0\n}\n\n.server-settings-highlighted {\n    font-size: 12px;\n    font-weight: 450;\n    color: #0095FF;\n    text-decoration: underline;\n}\n\n.servers-info-table {\n    border-collapse: collapse;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.servers-info-row {\n    border: none;\n    height: 34px;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 450;\n    padding: 5px;\n    color: var(--color-secondary-typography);\n}\n\n.servers-info-row:nth-child(odd) {\n    background-color: var(--color-content-sidebar);\n}\n\n.mainWrapper {\n    flex: 1;\n    height: 100vh;\n    display: flex;\n    align-items: flex-start;\n}\n\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    height: 100vh;\n    padding: 30px;\n    color: var(--color-main-typography)\n}\n\n.search-controls-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding: 0;\n}\n\n.search-field-container {\n    display: flex;\n    flex: 16;\n}\n\n.search-filter-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 3;\n}\n\n.content-heading {\n    margin-bottom: 40px;\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.content-container {\n    padding: 0;\n}\n\n.search-controls {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.search-container {\n    width: 444px;\n}\n\n@media screen and (max-width: 1000px) {\n    .server-content-info-url-container {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 5px;\n        margin-top: 20px\n    }\n\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-button": `automation_tab-button__oeCZP`,
	"notification-container": `automation_notification-container__dTmUN`,
	"add-layer-button": `automation_add-layer-button__rHLBH`,
	"tab-button-active": `automation_tab-button-active__hydKu`,
	"tab-content-container": `automation_tab-content-container__J85PV`,
	"form-textfield": `automation_form-textfield__b5Hvw`,
	"server-content": `automation_server-content__87chh`,
	"server-tabs-background": `automation_server-tabs-background__+ZUdC`,
	"server-content-info-url-container": `automation_server-content-info-url-container__FXeng`,
	"server-content-info-url-container-item": `automation_server-content-info-url-container-item__kqUNx`,
	"server-settings-button": `automation_server-settings-button__eX0k7`,
	"server-settings-secondary": `automation_server-settings-secondary__0oQHT`,
	"server-settings-highlighted": `automation_server-settings-highlighted__m2jCC`,
	"servers-info-table": `automation_servers-info-table__VgRuv`,
	"servers-info-row": `automation_servers-info-row__ddmD6`,
	"mainWrapper": `automation_mainWrapper__7hroN`,
	"rightBlock": `automation_rightBlock__EKup2`,
	"search-controls-container": `automation_search-controls-container__vYi1T`,
	"search-field-container": `automation_search-field-container__D9n5a`,
	"search-filter-container": `automation_search-filter-container__lOS9z`,
	"content-heading": `automation_content-heading__dpi01`,
	"content-container": `automation_content-container__6pkKq`,
	"search-controls": `automation_search-controls__mPm8g`,
	"search-container": `automation_search-container__pWwtg`,
	"content-heading-container": `automation_content-heading-container__NEqll`
};
export default ___CSS_LOADER_EXPORT___;
